import { AuditLogTab } from "@/components/settings/AuditLogTab";

export function SettingsAuditLogPage() {
  return <AuditLogTab />;
}
